<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
</style>

<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
    
           <FormItem :label="$t('userManage.addModel.groupName')" prop="groupName"  style="width: 500px">
                <SearchSelect ref="productType" :url="searchProductTypeUrl" labelName='groupName' isMultiple='2'  valName='id' keyword="groupName" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectVal($event,'groupName')"></SearchSelect>
            </FormItem>

            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SearchSelect from '../../common/selectList.vue';
import qs from 'qs'
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Array
        },
        name: "Model3",
        components: {
            SearchSelect
        },
        data() {
            return {   
                searchProductTypeUrl: this.config.urlArray.userGroups,
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                   groupName:'',
                   groupNameId:'',
                }, 
                
            }
        },
        watch:{
            showModel(val){
                if(val){
                    
                }
            },
        },
        computed:{
            local(){
                return this.$store.state.local
            },
            ruleCustom(){
                return {//验证
                    groupName: [
                        {required: true, type: 'string', message: this.$t('required'),trigger: 'change' },
                    ]
                }
            }

        },
        created(){
            
        },
        methods: {
            setSelectVal(e,key){
                // console.log('e',e)
                 this.formData[key] = e.nowData.label
                 this.formData[key+'Id'] =  e.nameVal+''
            },
            openOrClose(value) {
                if(value === true) {    
                    this.title = this.$t('userManage.addModel.title')
                    this.$nextTick(()=>{//select赋值
                        // this.$refs.productType.setQuery(null)
                        this.$refs.productType.setQuery(null)
                    }); 

                } else { //关闭弹框后要做的处理

                    this.resetForm();//重置表单
                    this.$refs.productType.clearVal()
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                       
                        let formDataArr ={
                            dealerUserGroupId:"",
                            userIds:[],
                        }
                        this.editFormData.map(item=>{
                            formDataArr.dealerUserGroupId = this.formData.groupNameId
                            formDataArr.userIds.push(item.userId)
                            // item.groupName = this.formData.groupName
                            // return item
                        })

                        // console.log(this.formData)
                        // console.log(formDataArr)

                        this.axios.post(this.config.urlArray.userGroupListShift, formDataArr).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })
                            
                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
            }
        }
    }
</script>
